import { EnergyMetric } from '../../model/energy-unit/energy-metric';
import { WeightMetric } from '../../model/prefixed-unit/weight.metric';
import { energyUnitFactors, unitFactors } from './unit-factors';

export function convertEnergyUnit(from: EnergyMetric, to: EnergyMetric, value: number, decimals?: number): number {
  if (from === to) {
    return value;
  }
  const exponent = energyUnitFactors[from] - energyUnitFactors[to];
  return _convert(value, exponent, decimals);
}

export function convertUnit(from: WeightMetric, to: WeightMetric, value: number, decimals?: number): number {
  if (from === to) {
    return value;
  }
  const exponent = unitFactors[from] - unitFactors[to];
  return _convert(value, exponent, decimals);
}

function _convert(value: number, exponent: number, decimals?: number): number {
  const convertedValue = value * Math.pow(10, exponent);
  if (decimals !== undefined) {
    return parseFloat(convertedValue.toFixed(decimals));
  } else {
    return convertedValue;
  }
}
